import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, FormHelperText, InputLabel, Select, Tooltip } from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';
import { Row, Col } from "react-bootstrap";
import { useController, useForm, useFormContext } from 'react-hook-form';

export default function ChildOptions(props) {

  const { name, onChange, id, variant, helpText, inputColumnSize, hideEmptyOption, onBlur, ...textFieldProps } = props;
  const formContext = useFormContext();
  const fallbackForm = useForm();
  const { control } = formContext ?? fallbackForm;
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control
  });
  const columnSize = inputColumnSize || 12;

  const empty = [<option aria-label="None" value="" key={0} />];

  const noOfChilds = props.noofchilds;
  let options = [];
  if (noOfChilds) {
    for (let i = 0; i < parseInt(noOfChilds); i++) {
      options.push({ value: `${i + 1}`, label: `${i + 1} Child` })
    }
  } else {
    options = [
      { value: '1', label: '1 Child' },
      { value: '2', label: '2 Children' },
      { value: '3', label: '3 Children' },
      { value: '4', label: '4 Children' },
      { value: '5', label: '5 Children' },
      { value: '6', label: '6 Children' },
      { value: '7', label: '7 Children' },
      { value: '8', label: '8 Children' },
    ];
  }

  const menuItems = options && options.map((option, key) => {
    return <option value={option.value} key={key + 1} disabled={option.disabled}>{option.label}</option>
  });

  var allMenuItems;

  if (hideEmptyOption) {
    allMenuItems = menuItems;
  } else if (menuItems) {
    allMenuItems = empty.concat(menuItems);
  } else {
    allMenuItems = empty;
  }

  const handleChange = (option) => {
    if (!option) field.onChange(null);
    else {
      field.onChange(option.target.value);
      onChange && onChange(option);
    }
  }

  const handleBlur = (event) => {
    field.onBlur(); // Ensures react-hook-form validation runs
    onBlur && onBlur(event); // Calls parent onBlur if provided
  };


  return (
    <Row>
      <Col xs={columnSize}>
        <FormControl
          fullWidth
          variant={variant || "filled"}
          error={!!error}
        >
          <InputLabel htmlFor={id}>{props.label}</InputLabel>
          <Select
            native
            onChange={handleChange}
            onBlur={handleBlur}
            {...textFieldProps}
            inputProps={{
              id: id,
            }}
          >
            {allMenuItems}
          </Select>
          <FormHelperText id={`${id}-helper-text`} aria-describedby={`${id}-helper-text`}>{error?.message}</FormHelperText>
        </FormControl>
      </Col>

      {helpText &&
        <Col xs={2}>
          <div className="d-flex mt-2">
            <Tooltip title={helpText}>
              <InfoIcon color="action"></InfoIcon>
            </Tooltip>
          </div>
        </Col>
      }
    </Row>
  )
}

ChildOptions.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  selectOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.any.isRequired,
    label: PropTypes.any.isRequired,
    disabled: PropTypes.bool,
  })),
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  variant: PropTypes.string,
  errors: PropTypes.object,
  hideEmptyOption: PropTypes.bool,
  helpText: PropTypes.string,
  onBlur: PropTypes.func,
};
